/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { getSnapshot } from 'mobx-state-tree';
/**
 * a set of APIs for widget operations in Exploration
 * @module WidgetAPI
 */
export default class WidgetAPI {
	constructor(widgetModel) {

		/**
		 * To be invoked by the product only.
		 */
		this.destroy = function() {
			widgetModel = null;
		};

		/**
		 * @return {string} id of this card
		 */
		this.getId = function() {
			return widgetModel.id;
		};

		/**
		 * @return {object} Snapshot of the state
		 */
		this.getState = function() {
			return getSnapshot(widgetModel);
		};

		/**
		 * @return {object} promise with nlt items
		 */
		this.getInsights = function(){
			return widgetModel.nlt.fetchItems();
		};

		/**
		 * @param {slotId} slot id of the widget, -1 means title
		 * @return {object} promise with badge info
		 */
		this.getBadgeInfoWhenReady = function(slotId){
			return widgetModel.getBadgeInfoWhenReady(slotId);
		};

	}
}



// WEBPACK FOOTER //
// ./src/js/api/WidgetAPI.js